/* npm version only adapted from https://github.com/component/bus */

import Emitter from 'component-emitter';

/**
 * Expose the event bus.
 */

export default new Emitter();



// WEBPACK FOOTER //
// ./src/modules/npm-component/bus.js